import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import useAuthStore from '@store/authStore'

/**
 * Componente per proteggere le route che richiedono autenticazione.
 * 
 * Se l'utente non è autenticato, viene reindirizzato alla pagina di login.
 * Mantiene la location originale per il redirect dopo il login.
 */
export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuthStore()
  const location = useLocation()

  // Mostra spinner durante il caricamento iniziale
  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <ArrowPathIcon className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    )
  }

  // Se non autenticato, redirect al login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Se autenticato, renderizza le route figlie
  return <Outlet />
}
